import twemoji from 'twemoji';

export default {
  install(Vue, opts) {
    if (opts) {
      // console.log(opts);
    }

    Vue.mixin({
      created: function() {
        twemoji.parse(document.body);
      },
    });
  },
};
